import React__default from 'react';

const width = 18;
const height = 19;
const IconReset = ({ fill = "black", size = 1 }) => {
    return (React__default.createElement("svg", { width: size * width, height: size * height, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.3359 3.66101L18.0079 0.989014H11.0079V7.98901L13.9259 5.07001C14.5289 5.66601 15.0319 6.36901 15.3899 7.17201C15.7879 8.06601 15.9889 9.01901 15.9889 10.007C15.9889 13.854 12.8589 16.984 9.01289 16.984C5.16589 16.984 2.03589 13.854 2.03589 10.007C2.03589 6.50501 4.63289 3.60501 7.99989 3.11201V1.09201C3.52589 1.59701 0.0358887 5.40001 0.0358887 10.007C0.0358887 14.957 4.06389 18.984 9.01289 18.984C13.9619 18.984 17.9889 14.957 17.9889 10.007C17.9889 8.73801 17.7299 7.51101 17.2169 6.35901C16.7579 5.32801 16.1099 4.42501 15.3359 3.66101Z", fill: fill })));
};

export { IconReset as default };
//# sourceMappingURL=IconReset.js.map
